<template>
  <b-card style="padding:40px;">
    <h5><b>LIST OF STOCKOUT</b></h5>
    <hr />
    <TableStockoutIndex
      :fields="fields.fields"
      :filter="this.filter"
      :page="this.page"
      :date="this.date"
      :main_outlet_name="this.main_outlet_name"
      :outlet_name="this.outlet_name"
    />
  </b-card>
</template>

<script>
import TableStockoutIndex from "@/table/user/stockout/TableStockoutIndex";

export default {
  data() {
    return {
      items: [],
      fields: {
        fields: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Outlet Name",
            key: "name",
            sortable: true,
            sortDirection: "asc"
          },
          {
            label: "Outlet Category",
            key: "category",
            sortable: true,
            sortDirection: "asc"
          },
          {
            label: "Date",
            key: "date",
            sortable: true,
            sortDirection: "asc"
          },
          {
            label: "Status",
            key: "status",
            sortable: true,
            sortDirection: "asc"
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      },

      filter: "",
      page: "",
      date: "",
      main_outlet_name: "",
      outlet_name: ""
    };
  },
  created() {
    if (this.$route.query.filter !== undefined) {
      this.filter = this.$route.query.filter;
      this.page = this.$route.query.page;
      this.date = this.$route.query.date;
      this.main_outlet_name = this.$route.query.main_outlet_name;
      this.outlet_name = this.$route.query.outlet_name;
    }
  },
  methods: {
    getStockout() {
      this.$store.dispatch("getStockout", {}).then(res => {
        let no = 0;
        res.data.data.data.forEach(element => {
          no = no + 1;
          let outletCat;
          if (element.outlet !== null) {
            outletCat = element.outlet.name;
          }
          this.items.push({
            no: no,
            name: element.outlet_name,
            category: outletCat,
            date: element.date,
            id: element.stock_id,
            type: element.type,
            status: element.status_details.desc,
            status_id: element.status
          });
        });
        this.totalRows = this.items.length;
      });
    }
  },
  components: {
    TableStockoutIndex
  }
};
</script>
<style lang="css" scoped></style>
